import styled, { css } from "styled-components";
import { parseCSS } from "scripts/FunctionsBundle";

// ################################ INTERFACES & PROPS ################################
type _Base = import("utils/class-types").Base;

type BreakerProps = {
  _size?: string;
} & _Base;

// ################################ RENDERING COMPONENT ################################

const _Breaker = (props: BreakerProps) => {
  return <div className={props.className} />;
};

// ################################ STYLES ################################

const Breaker = styled(_Breaker).attrs((props): BreakerProps => {
  return {
    _size: "3rem",
    ...props,
  };
})`
  ${(props) => css`
    position: relative;
    flex: none;

    height: ${props._size};

    ${parseCSS(props._style)}
  `}
`;

// ################################ EXPORTS ################################

export default Breaker;
